import { render, staticRenderFns } from "./PageAll.vue?vue&type=template&id=5f5b649b&scoped=true&"
import script from "./PageAll.vue?vue&type=script&lang=js&"
export * from "./PageAll.vue?vue&type=script&lang=js&"
import style0 from "./PageAll.vue?vue&type=style&index=0&id=5f5b649b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b649b",
  null
  
)

export default component.exports